import { ITradeInput } from "src/store/features/TargetOrdersV2.slice";
import TradeCoinSelectionButton from "./TradeCoinSelectionButton";
import { TradeType } from "../types";

interface AssetSelectorProps {
  orderType: "Buy" | "Sell";
  sellAssetSide: ITradeInput;
  buyAssetSide: ITradeInput;
  side: "buy" | "sell";
  tradeType?: TradeType;
}

// temporary solution to handle trade types specifically for target orders
// this should be refactored in the future
export function AssetSelector({
  orderType,
  sellAssetSide,
  buyAssetSide,
  side,
  tradeType = "target",
}: AssetSelectorProps) {
  if (side === "sell") {
    return (
      <TradeCoinSelectionButton
        code={orderType === "Sell" ? sellAssetSide.code || "Select" : buyAssetSide.code || "Select"}
        logoURL={orderType === "Sell" ? sellAssetSide.logoURL || "" : buyAssetSide.logoURL || ""}
        maxTotal={orderType === "Sell" ? sellAssetSide.maxTotal : buyAssetSide.maxTotal}
        action={orderType === "Sell" ? "sell" : "buy"}
        tradeType={tradeType}
        tokenType={orderType === "Sell" ? "all" : "crypto"}
      />
    );
  } else {
    return (
      <TradeCoinSelectionButton
        code={orderType === "Sell" ? buyAssetSide.code || "Select" : sellAssetSide.code || "Select"}
        logoURL={orderType === "Sell" ? buyAssetSide.logoURL || "" : sellAssetSide.logoURL || ""}
        maxTotal={orderType === "Sell" ? buyAssetSide.maxTotal : sellAssetSide.maxTotal}
        action={orderType === "Sell" ? "buy" : "sell"}
        tradeType={tradeType}
        tokenType={orderType === "Buy" ? "crypto" : "all"}
      />
    );
  }
}
